import { Dialog, DialogContent } from "@material-ui/core";
import * as React from "react";

interface IOwnProps {
  open: boolean;
  onClose: () => void;
  children: JSX.Element;
}

const FormModal = ({ onClose, open, children }: IOwnProps) => {
  return (
    <Dialog open={open} onClose={() => onClose()}>
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
};

export default FormModal;
